<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-layers" /> {{ caption }}
        <div class="card-header-actions">
          <CRow>
            <CCol md="12" style="display:flex;">
              <div role="group" class="form-group" style="margin-bottom: 0px;">
                <CButton color="success" size="sm" @click="downloadExcel()">Exportar</CButton>
                <CButton color="info" size="sm" @click="storeModal()">Nueva Propiedad</CButton>
              </div>
            </CCol>
          </CRow>
        </div>
      </slot>
    </CCardHeader>

    <CCardBody>
      <!-- Filtros -->
      <CRow class="mb-3">
        <CCol md="3">
          <div role="group" class="form-group" style="margin: -10px 0px 10px">
            <label>Tipo:</label>
            <CSelect
              :value.sync="filters.property_type"
              :options="propertyTypeOptions"
              @change="changeFilters"
            />
          </div>
        </CCol>

        <CCol md="3">
          <div role="group" class="form-group" style="margin: -10px 0px 10px">
            <label>Departamento:</label>
            <CSelect
              :value.sync="filters.asset_departament_id"
              :options="departamentsOptions"
              @change="changeFilters"
            />
          </div>
        </CCol>
        <CCol md="3">
          <div role="group" class="form-group" style="margin: -10px 0px 10px">
            <label>Resguardo:</label>
            <CSelect
              :value.sync="filters.asset_person_id"
              :options="personsOptions"
              @change="changeFilters"
            />
          </div>
        </CCol>
        <CCol md="3">
          <div role="group" class="form-group" style="margin: -10px 0px 10px">
            <label>Status:</label>
            <CSelect
              :value.sync="filters.is_active"
              :options="statusOptions"
              @change="changeFilters"
            />
          </div>
        </CCol>
      </CRow>

      <CRow class="mb-2">
        <CCol md="12">
          <div role="group" class="form-group" style="margin: -10px 0px 10px">
            <label>Buscar:</label>
            <CInput
              :lazy="false"
              :value.sync="filters.search"
              @input="onSearchInput"
              placeholder="Código, propiedad, tipo, departamento, resguardo..."
            />
          </div>
        </CCol>
      </CRow>

      <!-- Tabla -->
      <CRow>
        <CCol sm="12">
          <CDataTable
            :items="items"
            :fields="fields"
            :hover="hover"
            :striped="striped"
            :border="border"
            :small="small"
            :fixed="fixed"
            :dark="dark"
            sorter
          >
            <template #code="{ item }">
              <td>{{ item.code }}</td>
            </template>

            <template #name="{ item }">
              <td>
                <strong>{{ item.name }}</strong><br>
                <small>{{ item.location }}</small>
              </td>
            </template>

            <template #type="{ item }">
              <td>{{ item.type || '-' }}</td>
            </template>

            <template #departament="{ item }">
              <td>{{ item.departament || '-' }}</td>
            </template>

            <template #person="{item}">
              <td class="text-center w300">
                <span v-if="item.is_active && item.person">{{item.person}}</span>
                <span v-if="item.is_active && !item.person"><CButton v-if="item.is_active" color="warning" size="sm" @click="assignModal(item)">Asignar</CButton></span>
                <span v-if="item.is_active && item.person">
                  <br /><br />
                  <CButton v-if="item.is_active && 0" color="info" size="sm" @click="assignModal(item)" style="height: 28px; margin-right: 10px;">Traslado</CButton>
                  <CButton v-if="item.is_active" color="warning" size="sm" @click="reAssignModal(item)" style="height: 28px;">Reasignar</CButton>
                </span>
              </td>
            </template>

            <template #actions="{ item }">
              <td style="padding: 0px; padding-bottom: 2px;" class="table_actions w150 text-center">
                <CButton color="info" size="sm" @click="showProfileModal(item)">Ficha</CButton>
                <CButton color="dark" size="sm" @click="documentModal(item)">Docs</CButton>
                <CButton v-if="!item.is_trash" color="warning" size="sm" @click="editModal(item)"><CIcon name="cil-pencil"/></CButton>
                  <template v-if="item.is_active">
                    <CButton color="danger" size="sm" @click="deactiveModal(item)"><CIcon name="cil-ban"/></CButton>
                  </template>
                  <template v-if="!item.is_active && !item.is_trash">
                    <CButton color="danger" size="sm" @click="deleteModal(item)"><CIcon name="cil-trash"/></CButton>
                  </template>
                  <template v-if="!item.is_active && !item.is_trash">
                    <CButton color="success" size="sm" @click="activeModal(item)"><CIcon name="cil-check-circle"/></CButton>
                  </template>
              </td>
            </template>
          </CDataTable>
          <div class="d-flex justify-content-between align-items-center mt-2">
            <span style="font-size: 12px;">Total: {{ paginationData.totalItems }} registros</span>
            <CPagination
              :active-page.sync="currentPageLocal"
              :pages="paginationData.totalPages"
              size="sm"
              align="end"
              @update:activePage="onPageChange"
            />
          </div>
        </CCol>
      </CRow>
    </CCardBody>

    <!-- Modales -->
    <PropertyModal
      ref="addModal"
      @store="storeProcess"
      @update="updateProcess"
    />
    <PropertyProfileModal ref="profileModal" @updated="handleProfileUpdated"/>
    <PropertiesImportModal
      ref="importModal"
      @import="importProcess"
    />
    <PropertyAssignModal
      ref="assignModal"
      @store="storeProcessAssign"
      @update="updateProcessAssign"
    />
    <DeleteModal
      ref="deleteModal"
      @confirm="deleteProcess"
    />
    <PropertyDocumentModal ref="documentModal" @store="storeProcessDocument" @delete="deleteProcessDocument"/>
  </CCard>
</template>

<script>
import PropertyModal from './PropertyModal.vue'
import PropertyProfileModal from './PropertyProfileModal.vue'
import PropertiesImportModal from './PropertiesImportModal.vue'
import PropertyAssignModal from './PropertyAssignModal.vue'
import PropertyDocumentModal from './PropertyDocumentModal.vue'
import DeleteModal from '../global/ConfirmModal.vue'

import ws from '../../services/properties'
import ws_typ from '../../services/asset_types'
import ws_dep from '../../services/asset_departaments'
import ws_per from '../../services/asset_persons'
import store from '../../store'

export default {
  name: 'PropertiesCatalogTable',
  components: {
    PropertyModal,
    PropertyProfileModal,
    PropertiesImportModal,
    PropertyAssignModal,
    PropertyDocumentModal,
    DeleteModal
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    paginationData: {
      type: Object,
      default: () => ({
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        perPage: 30,
      })
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data () {
    return {
      fields: [
        { key: 'code', label: 'Código', _style: 'width:10%' },
        { key: 'name', label: 'Propiedad', _style: 'width:30%' },
        { key: 'type', label: 'Tipo', _style: 'width:15%' },
        { key: 'departament', label: 'Departamento', _style: 'width:15%' },
        { key: 'person', label: 'Resguardo', _style: 'width:20%' },
        { key: 'actions', label: 'Acciones', _style: 'width:10%' }
      ],
      filters: {
        search: '',
        asset_type_id: 0,
        asset_departament_id: 0,
        property_type: '',
        is_active: '',
        asset_person_id: 0
      },
      idToDelete: null,
      moduleDelete: '',
      typesOptions: [{ value: 0, label: 'Todos' }],
      departamentsOptions: [{ value: 0, label: 'Todos' }],
      personsOptions: [{ value: 0, label: 'Todos' }],
      propertyTypeOptions: [
        { value: '', label: 'Todos' },
        { value: 'Propio', label: 'Propio' },
        { value: 'Arrendamiento', label: 'Arrendamiento' },
        { value: 'Arrendatario', label: 'Arrendatario' },
        { value: 'Otro', label: 'Otro' }
      ],
      statusOptions: [
        { value: '', label: 'Todos' },
        { value: 1, label: 'Activos' },
        { value: 0, label: 'Inactivos' }
      ],
      searchDebounceTimer: null,
      currentPageLocal: 1
    }
  },
  watch: {
    'paginationData.currentPage': {
      handler (value) {
        this.currentPageLocal = value || 1
      },
      immediate: true
    }
  },
  async mounted () {
    await this.initFilters()
  },
  beforeDestroy () {
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer)
    }
  },
  methods: {
    onSearchInput () {
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer)
      }

      this.searchDebounceTimer = setTimeout(() => {
        this.emitRefresh(1)
      }, 350)
    },
    emitRefresh (page = this.currentPageLocal, options = {}) {
      const filters = { ...this.filters }
      if (!filters.search || !filters.search.toString().trim()) {
        delete filters.search
      }
      if (filters.is_active === '' || filters.is_active === null || filters.is_active === undefined) {
        delete filters.is_active
      }

      this.$emit('refreshItems', { filters, page, ...options })
    },
    onPageChange (page) {
      this.emitRefresh(page)
    },
    async initFilters () {
      this.loading()
      try {
        const responseTyp = await ws_typ.get({ type: 'PROPERTIES' })
        if (responseTyp.type === 'success') {
          this.typesOptions = [{ value: 0, label: 'Todos' }].concat(
            responseTyp.data.map(t => ({ value: t.id, label: t.name }))
          )
        }

        const responseDep = await ws_dep.get()
        if (responseDep.type === 'success') {
          this.departamentsOptions = [{ value: 0, label: 'Todos' }].concat(
            responseDep.data.map(d => ({ value: d.id, label: d.name }))
          )
        }

        const responsePer = await ws_per.get()
        if (responsePer.type === 'success') {
          this.personsOptions = [{ value: 0, label: 'Todos' }].concat(
            responsePer.data.map(p => ({ value: p.id, label: p.name }))
          )
        }
      } finally {
        this.loaded()
      }
    },

    // Filtros → recargar datos en el padre
    changeFilters () {
      this.emitRefresh(1)
    },

    // Modales principales
    storeModal () {
      this.$refs.addModal.openModal()
    },
    editModal (item) {
      this.$refs.addModal.openModal(item)
    },
    async showProfileModal (item) {
      this.loading()
      try {
        const response = await ws.show({ id: item.id })
        if (response.type === 'success') {
          this.$refs.profileModal.openModal(response.data)
        } else {
          this.showToast(response.type, response.message)
        }
      } finally {
        this.loaded()
      }
    },
    handleProfileUpdated () {
      this.emitRefresh()
    },
    importModal () {
      this.$refs.importModal.openModal()
    },
    assignModal (item) {
      console.log("assignModal")
      console.log(item)
      this.$refs.assignModal.storeModal(item);
    },
    reAssignModal (item) {
      this.$refs.assignModal.updateModal(item);
    },
    unassignModal (item) {    
      this.idToDelete = item.id;
      this.moduleDelete = "unassign";
      let color = "warning";
      let title = "Desasignar Persona";
      let content = "Esta seguro que quiere desasignar a " +item.person+" del siguiente activo?"
      let confirm = item.code + " - " + item.name
      this.$refs.deleteModal.show(color,title,content,confirm);
    },  
    documentModal (item) {
      this.loading()
      ws.show({ id: item.id }).then((response) => {
        if (response.type === 'success') {
          this.$refs.documentModal.storeModal(response.data)
        } else {
          this.showToast(response.type, response.message)
        }
      }).finally(() => {
        this.loaded()
      })
    },

    // Acciones CRUD hacia el backend
    async storeProcess (form) {
      this.loading()
      try {
        const response = await ws.store(form)
        if (response.type === 'success') {
          this.showToast('success', 'Propiedad guardada correctamente.')
          this.emitRefresh(1, { prioritizeNew: true, pinItem: response.data || null })
        }
      } finally {
        this.loaded()
      }
    },
    async updateProcess (form) {
      this.loading()
      try {
        const response = await ws.update(form)
        if (response.type === 'success') {
          this.showToast('success', 'Propiedad actualizada correctamente.')
          this.emitRefresh()
        }
      } finally {
        this.loaded()
      }
    },
    async importProcess (formData) {
      this.loading()
      try {
        const response = await ws.import(formData)
        if (response.type === 'success') {
          this.showToast('success', 'Propiedades importadas correctamente.')
          this.emitRefresh(1)
        }
      } finally {
        this.loaded()
      }
    },

    async storeProcessAssign (form) {
      this.loading()
      try {
        const response = await ws.assign(form)
        if (response.type === 'success') {
          this.showToast('success', 'Resguardo asignado correctamente.')
          this.emitRefresh()
        }
      } finally {
        this.loaded()
      }
    },
    async updateProcessAssign (form) {
      this.loading()
      try {
        const response = await ws.assign(form) // o ws.updateAssign si lo separas
        if (response.type === 'success') {
          this.showToast('success', 'Resguardo actualizado correctamente.')
          this.emitRefresh()
        }
      } finally {
        this.loaded()
      }
    },

    // Eliminar, activar, desactivar
    deleteModal (item) {
      this.idToDelete = item.id
      this.moduleDelete = 'delete'
      const color = 'danger'
      const title = 'Eliminar Registro'
      const content = '¿Estás seguro que deseas eliminar el registro?'
      const confirm = `<span style="font-size:16px;font-weight:bold;">${item.code}</span><br/><span style="font-size:14px;">${item.name}</span>`
      this.$refs.deleteModal.show(color, title, content, confirm)
    },
    deactiveModal (item) {
      this.idToDelete = item.id
      this.moduleDelete = 'deactive'
      const color = 'warning'
      const title = 'Desactivar Registro'
      const content = '¿Estás seguro que deseas desactivar el registro?'
      const confirm = `<span style="font-size:16px;font-weight:bold;">${item.code}</span><br/><span style="font-size:14px;">${item.name}</span>`
      this.$refs.deleteModal.show(color, title, content, confirm)
    },
    activeModal (item) {
      this.idToDelete = item.id
      this.moduleDelete = 'active'
      const color = 'success'
      const title = 'Reactivar Registro'
      const content = '¿Estás seguro que deseas reactivar el registro?'
      const confirm = `<span style="font-size:16px;font-weight:bold;">${item.code}</span><br/><span style="font-size:14px;">${item.name}</span>`
      this.$refs.deleteModal.show(color, title, content, confirm)
    },

    async deleteProcess () {
      if (!this.idToDelete) return

      this.loading()
      try {
        let response
        if (this.moduleDelete === 'delete') {
          response = await ws.delete({ id: this.idToDelete })
        } else if (this.moduleDelete === 'deactive') {
          response = await ws.deactive({ id: this.idToDelete })
        } else if (this.moduleDelete === 'active') {
          response = await ws.active({ id: this.idToDelete })
        }

        if (response && response.type === 'success') {
          this.showToast('success', 'Operación realizada correctamente.')
          this.emitRefresh()
        }
      } finally {
        this.loaded()
      }
    },

    // Descargas
    async downloadExcel () {
      this.loading()
      try {
        const filters = { ...this.filters }
        if (!filters.search || !filters.search.toString().trim()) {
          delete filters.search
        }
        if (filters.is_active === '' || filters.is_active === null || filters.is_active === undefined) {
          delete filters.is_active
        }

        await ws.downloadExcel(filters)
      } finally {
        this.loaded()
      }
    },
    async downloadRecord (item) {
      this.loading()
      try {
        const response = await ws.downloadRecord({ id: item.id })
        if (response.type === 'success') {
          window.open(response.data.url, '_blank')
        }
      } finally {
        this.loaded()
      }
    },

    async storeProcessDocument (form) {
      this.loading()
      try {
        const response = await ws.storeDocument(form)
        if (response.type === 'success') {
          this.showToast('success', 'Documento guardado correctamente.')
          this.emitRefresh()
        }
      } finally {
        this.loaded()
      }
    },
    async deleteProcessDocument (form) {
      this.loading()
      try {
        const response = await ws.deleteDocument(form)
        if (response.type === 'success') {
          this.showToast('success', 'Documento eliminado correctamente.')
          this.emitRefresh()
        }
      } finally {
        this.loaded()
      }
    },

    showToast (type, message) {
      store.commit('toast', { color: type, message })
    },
    loading () {
      store.commit('loading')
    },
    loaded () {
      store.commit('loaded')
    }
  }
}
</script>
